import React from 'react';
import { Typography, Stack } from '@mui/material';
import { convertLimitTemperature } from '../devices/util/convert-temp-units';
export function SetpointProfileValues({
  profile,
  units,
  currentUnits = 'C',
}: {
  profile?: {
    _id?: string;
    name?: string | null;
    heat?: { min?: number | null; max?: number | null } | null;
    cool?: { min?: number | null; max?: number | null } | null;
  };
  units: 'C' | 'F';
  currentUnits?: 'C' | 'F';
}) {
  if (!profile || profile._id === '0')
    return (
      <Typography>
        Using device-specific defaults. Each thermostat uses its published
        equipment domains.
      </Typography>
    );
  const value = (number?: number | null) =>
    convertLimitTemperature(number, units, currentUnits) ?? 'unavailable';
  return (
    <Stack spacing={1}>
      <Typography>
        Setpoint profile: {profile.name ?? 'Unnamed profile'}
      </Typography>
      <Typography>
        Heat: {value(profile.heat?.min)}–{value(profile.heat?.max)} °{units}
      </Typography>
      <Typography>
        Cool: {value(profile.cool?.min)}–{value(profile.cool?.max)} °{units}
      </Typography>
      <Typography variant="caption">
        Equipment compatibility is checked for every affected thermostat before
        assignment.
      </Typography>
    </Stack>
  );
}
